import { createReducer } from 'angieslist-app-platform';

const initialState = {
  userId: '',
  activityLocation: '',
  userType: 'Visitor - New',
};

const appReducer = createReducer(
  initialState,
  {
    MEMBER_DETECTION: (state, action) => ({
      ...state,
      userId: action.payload.userId,
    }),
    ACTIVITY_LOCATION: (state, action) => ({
      ...state,
      activityLocation: action.payload.activityLocation,
    }),
    USER_TYPE: (state, action) => ({
      ...state,
      userType: action.payload.userType,
    }),
  },
  false
);

export default appReducer;



// WEBPACK FOOTER //
// ./src/app/browser/redux/appReducer.js